import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import api from "utils/api";
import APIConstant from "utils/constant";
import { CommonConfig } from "CommonConfig";
// import ReactToPrint from "react-to-print";
import moment from "moment";
import cogoToast from "cogo-toast";

const POSListing = (props) => {
  const [userId, setUserId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [search, setSearch] = useState("");
  const [posId, setPosId] = useState("");
  const [posList, setPOSList] = useState([]);
  const [posItems, setPOSItems] = useState([]);
  const [posDialog, setPOSDialog] = useState(false);
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions,
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage,
  );
  const [templateHtml, setTemplateHtml] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [previewDialog, setPreviewDialog] = useState(false);
  const [printData, setPrintData] = useState({});
  const [barcodeConfig, setBarcodeConfig] = useState([]);
  const [content, setContent] = useState({
    header: "",
    footer: "",
    image: "",
  });

  // const printButtonRef = useRef(null);
  const componentRef = useRef(null);

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");

    // if (lockstatus == 0) {
    if (token !== null) {
      setUserId(data);
      setUserPageAccess(userPageAccess);
      GetPOSList(data);
      GetBarcodeConfigurationByConfigName(data);
      GetImageConfiguration(data);
    } else {
      props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  }, []);

  const GetPOSList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetPOSList, params)
      .then((response) => {
        if (response.Success === 1) {
          setPOSList(response.Data);
        }
      })
      .catch((err) => {});
  };

  const GetImageConfiguration = async (UserId) => {
    try {
      let paramData = {
        UserId: UserId,
      };
      await api
        .post(APIConstant.path.GetImageConfiguration, paramData)
        .then(async (response) => {
          let resp = await response;
          if (resp?.success) {
            const image = `${process.env.REACT_APP_NODE_API_ENDPOINT}/document/${resp?.data[0]?.ImagePath}`;
            setContent({
              header: resp?.data[0]?.Header,
              footer: resp?.data[0]?.Description,
              image: image,
            });
          }
        });
    } catch (error) {
      console.log("load script image", error);
    }
  };

  const GetBarcodeConfigurationByConfigName = async (UserId) => {
    try {
      let data = {
        UserId,
        ConfigName: "Billing Configuration",
      };
      await api
        .post(APIConstant.path.GetBarcodeConfigurationByConfigurationName, data)
        .then(async (res) => {
          let response = await res;
          if (response.Success === 1) {
            setBarcodeConfig(response.Data);
          }
        })
        .catch((err) => {
          console.log({ err });
        });
    } catch (err) {
      console.log({ err });
    }
  };

  const GetRenderTemplate = async (Data, Type) => {
    try {
      let paramData = {
        UserId: userId,
        PrintData: Data,
        ConfigurationName: "Billing Configuration",
        Type,
      };
      await api
        .post(APIConstant.path.GetRenderTemplate, paramData)
        .then(async (response) => {
          if (response.Success === 1) {
            setTemplateHtml(response.Html);
          }
        });
    } catch (error) {
      console.log("load script image", error);
    }
  };

  const DeletePOS = async (e) => {
    try {
      let params = {
        POSId: posId,
        UserId: userId,
      };
      await api
        .post(APIConstant.path.DeletePOS, params)
        .then(async (response) => {
          let res = await response;
          if (res?.Success === 1) {
            cogoToast.success(res?.Message);
            setPosId("");
            setShowDeleteModal(false);
            await GetPOSList(userId);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const actionTemplate = (rowData, props) => {
    return (
      <div class="bill-action icon-only-btn" style={{ display: "flex" }}>
        <div onClick={(e) => handleOpen(rowData, "Print")}>
          <i class="pi pi-print"></i>
        </div>
        <div onClick={(e) => handleOpen(rowData, "View")}>
          <i class="icon-view"></i>
        </div>

        {/* {userPageAccess.includes("Edit Branch") ? ( */}
        <i
          onClick={(e) => handleOpen(rowData, "Edit")}
          class="icon-editImage"
        ></i>
        {/* ) : null} */}
        {/* {userPageAccess.includes("Delete Branch") ? ( */}
        <i
          onClick={(e) => handleOpen(rowData, "Delete")}
          class="icon-delete"
        ></i>
        {/* ) : null} */}
      </div>
    );
  };

  const handleOpen = async (data, type) => {
    if (type === "View") {
      setPOSItems(data.ProductList || []);
      setPOSDialog(true);
    } else if (type === "Edit") {
      props.history.push({
        pathname: "/admin/add-pos",
        state: {
          PosId: data?._id,
          Type: "Edit",
        },
      });
    } else if (type === "Delete") {
      setShowDeleteModal(true);
      setPosId(data._id);
    } else if (type === "Print") {
      const gstWiseList = data.ProductList?.reduce((acc, item) => {
        const gst = item.GstName || "";
        if (!acc[gst]) {
          acc[gst] = [];
        }
        acc[gst].push(item);
        return acc;
      }, {});
      let tempData = {
        ...data,
        PrintDate: new Date(),
        ServiceCharges: data.ServiceCharges || [],
        GstWiseProductList: gstWiseList,
        CustomerDetails: {
          CustomerName: data.CustomerName,
          ContactNo: data.ContactNo,
          Date: data.POSDate,
        },
      };

      await GetRenderTemplate(tempData, "Billing Template");

      setPrintData(tempData);
      setPreviewDialog(true);
      // if (printButtonRef) {
      //   printButtonRef.current.click();
      // }
    }
  };

  const handleClose = () => {
    setPOSItems([]);
    setPOSDialog(false);
  };

  // const printBill = async () => {
  //   try {
  //     let params = {
  //       UserId: userId,
  //       PrintData: printData,
  //     };
  //     await api.post(APIConstant.path.PrintBill, params).then((response) => {
  //       if (response.Success === 1) {
  //         cogoToast.success(response.Message);
  //       } else {
  //         cogoToast.error(response.Message);
  //       }
  //     });
  //   } catch (e) {}
  // };
  const printBill = async () => {
    try {
      const configMap = {};
      (barcodeConfig || []).forEach((item) => {
        configMap[item.value] = item.checked;
      });
      const response = await fetch("http://localhost:3333/print-bill", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          PrintData: printData,
          ConfigMap: configMap,
          Content: content,
        }),
      });

      const result = await response.json();

      if (result.Success === 1) {
        cogoToast.success(result.Message || "Printed successfully");
      } else {
        cogoToast.error(result.Message || "Print failed");
      }
    } catch (err) {
      console.error(err);
      cogoToast.error(
        "Local printer service not running. Please start the printer service.",
      );
    }
  };

  return (
    <div className="main-access-contianer">
      <div className="heading-area">
        <h3>POS List</h3>
        <div className="heading-area-right">
          <div className="searchbar-area p-as-center">
            <InputText
              type="search"
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 10 }}
            />
            <i className="icon-search"></i>
          </div>
        </div>
      </div>

      <div className="main-access-card-master">
        <DataTable
          className="main-table table-td"
          value={posList}
          editMode="row"
          dataKey="id"
          responsiveLayout="scroll"
          paginator={true}
          rows={rowsPerPage}
          totalRecords={posList.length}
          rowsPerPageOptions={rowsPerPageOptions}
          globalFilter={search}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "20%" }}
          ></Column>
          <Column
            field="POSDate"
            header="Date"
            style={{ width: "20%" }}
            body={(rowData) =>
              rowData.POSDate
                ? moment(rowData.POSDate).format("DD/MM/YYYY")
                : ""
            }
          ></Column>
          <Column
            field="BillNo"
            header="Bill No"
            style={{ width: "20%" }}
          ></Column>
          {/* 
          <Column
            field="CustomerName"
            header="Customer"
            style={{ width: "20%" }}
          ></Column>
          <Column
            field="ContactNo"
            header="ContactNo"
            style={{ width: "20%" }}
          ></Column> */}
          <Column
            field="Items"
            header="Total Items"
            style={{ width: "20%" }}
            body={(rowData) => rowData.ProductList?.length || 0}
          ></Column>
          <Column
            field=""
            header="Total Amount"
            style={{ width: "20%" }}
            body={(rowData) => {
              let total = 0;
              if (rowData.ProductList?.length) {
                rowData.ProductList.forEach((pr) => {
                  total += pr.SubTotal;
                });
              }
              if (rowData.ServiceCharges?.length) {
                rowData.ServiceCharges.forEach((sc) => {
                  total += sc.Amount;
                });
              }
              return total;
            }}
          ></Column>
          <Column
            field="Payment"
            header="Payment"
            style={{ width: "20%" }}
          ></Column>
          <Column
            field="Action"
            header="Action"
            style={{ width: "20%" }}
            body={actionTemplate}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        className="stock-modal"
        open={posDialog}
        onClose={(e) => handleClose()}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Items</div>

          <div className="dialog-close" onClick={(e) => handleClose()}>
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <div className="main-access-card-master">
          <DataTable
            className="main-table table-td"
            value={posItems}
            editMode="row"
            dataKey="id"
            responsiveLayout="scroll"
            paginator={false}
            totalRecords={posItems.length}
            emptyMessage="No records found"
            responsive={false}
            resizableColumns={true}
            columnResizeMode="fit"
            scrollable={true}
            scrollWidth="auto"
          >
            <Column
              field="Index"
              header="Sr.No"
              body={actionBodyTemplateSrNo}
              style={{ width: "20%" }}
            ></Column>
            <Column
              field="Product"
              header="Item Name"
              style={{ width: "20%" }}
            ></Column>
            <Column
              field="UnitName"
              header="Unit Name"
              style={{ width: "20%" }}
            ></Column>
            <Column
              field="Quantity"
              header="Quantity"
              style={{ width: "20%" }}
            ></Column>
            <Column field="Mrp" header="Mrp" style={{ width: "20%" }}></Column>
            <Column
              field="Rate"
              header="Rate"
              style={{ width: "20%" }}
            ></Column>
            <Column
              field="SubTotal"
              header="SubTotal"
              style={{ width: "20%" }}
            ></Column>
          </DataTable>
          <DialogActions className="p-p-0 dialog-footer1">
            <Button className="primary-btn1" onClick={(e) => handleClose("")}>
              Close
            </Button>
          </DialogActions>
        </div>
      </Dialog>

      {/* <ReactToPrint
        trigger={() => (
          <div className="p-d-none">
            <button ref={printButtonRef}>Print</button>
          </div>
        )}
        content={() => componentRef?.current}
        documentTitle="POS"
        onAfterPrint={() => {}} 
      /> */}

      {/* <div className="p-d-none">
        <div className="im-p-dp details-variant-print" ref={componentRef}>
          <div
            dangerouslySetInnerHTML={{
              __html: templateHtml,
            }}
          />
        </div>
      </div> */}

      <Dialog
        open={previewDialog}
        onClose={() => setPreviewDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Preview Bill</DialogTitle>
        <DialogContent>
          <div className="im-p-dp details-variant-print">
            <div
              dangerouslySetInnerHTML={{
                __html: templateHtml,
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPreviewDialog(false)}>Close</Button>
          <Button onClick={printBill} color="primary" autoFocus>
            Print
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setPosId("");
        }}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Details & Variant Master</div>
          <div
            className="dialog-close"
            onClick={() => {
              setShowDeleteModal(false);
              setPosId("");
            }}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <h6>Are you sure want to delete this?</h6>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => {
              setShowDeleteModal(false);
              setPosId("");
            }}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => DeletePOS(e)}
            type="submit"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default POSListing;
